// ============================================================================
//  Helper d'appel API centralisé.
//
//  Objectif : remplacer progressivement les fetch() éparpillés qui mélangent
//  trois conventions d'URL ("https://ogog.ch/...", "/backend/...", "./backend/...").
//
//  - API_BASE vaut '' en production (le site est servi depuis ogog.ch, donc les
//    chemins relatifs /backend/... fonctionnent).
//  - En développement (Parcel sur localhost), définir API_BASE pour pointer vers
//    l'API de prod, via une variable d'environnement Parcel :
//        API_BASE=https://ogog.ch parcel public/index.html
//
//  apiFetch() vérifie response.ok (les fetch actuels parsent du JSON sans vérifier
//  le statut → plantage silencieux sur une 500 renvoyant du HTML).
//
//  Migration recommandée (incrémentale, serveur de dev lancé pour tester) :
//    import { apiFetch } from "../api";
//    const data = await apiFetch("/backend/api/get_users.php");
//  Pour les endpoints authentifiés (session), passer { credentials: "include" }.
// ============================================================================

export const API_BASE = (typeof process !== "undefined" && process.env && process.env.API_BASE) || "";

/**
 * Appelle l'API et renvoie le JSON (ou le texte) en vérifiant le statut HTTP.
 * @param {string} path   Chemin commençant par "/backend/...".
 * @param {object} options Options fetch (method, body, headers, credentials...).
 * @throws {Error} si la réponse HTTP n'est pas 2xx.
 */
export async function apiFetch(path, options = {}) {
  const res = await fetch(API_BASE + path, options);
  const contentType = res.headers.get("content-type") || "";

  if (!res.ok) {
    let message = `Erreur ${res.status}`;
    if (contentType.includes("application/json")) {
      try {
        const data = await res.json();
        if (data && data.message) message = data.message;
      } catch (_) {
        /* corps non-JSON : on garde le message générique */
      }
    }
    throw new Error(message);
  }

  if (contentType.includes("application/json")) return res.json();
  return res.text();
}
